import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    mainAboutusContainer: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    checkoutBoxMianDiv: {
      margin: 45,
      marginTop: 0,
      marginRight: 0,
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        margin: 0,
        marginTop: 15,
        width: "100%",
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      color: "#666",
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    stepperroot: {
      width: "100%",
    },
    stepperbutton: {
      marginRight: theme.spacing(1),
    },
    stepperinstructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    StepperPage: {
      padding: 30,
      backgroundColor: "#fff",
      marginTop: 20,
    },
    buttons: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "center",
    },
    checkoutTitleBox: {
      display: "flex",
      alignItems: "center",
      borderLeft: "3px solid " + myTheme.palette.primary.main,
      padding: 20,
      backgroundColor: "#fff",
      marginTop: 20,
    },
    mainCheckoutBox: {
      backgroundColor: "#fff",
      padding: 22,
      paddingTop: 10,
      borderTop: "0.06px solid #e9e9e9",
    },
    goToStoreBtn: {
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
        color: myTheme.palette.primary.contrastText,
      },
      marginTop: 20,
      width: "100%",
      padding: 15,
    },
    checkoutProductImg: {
      width: 60,
      height: 60,
      objectFit: "cover",
      border: "0.1px solid #e9e9e9",
      marginRight: 10,
    },
    paymentMethodBox: {
      padding: 30,
      display: "flex",
      alignItems: "center",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
      marginTop: 25,
      // justifyContent:'center'
    },
    ".StripeCheckout": { display: "none" },
    orderConfirmationPage: {
      padding: 10,
      paddingTop: 2,
      backgroundColor: "#fff",
      marginTop: 20,
      paddingBottom: 60,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      // borderLeft:'3px solid '+myTheme.palette.primary.main
    },
    confirmationImage: {
      maxWidth: 200,
      maxHeight: 200,
    },
    actionButtons: {
      display: "flex",
      marginTop: 10,
      justifyContent: "space-evenly",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection: "column",
      },
    },
    continueShoppingBtn: {
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
        color: myTheme.palette.primary.contrastText,
      },
      padding: 15,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "100%",
        marginTop:5
      },
    },
    receiptHeaderHeadings:{
      display: "flex", 
      justifyContent: "space-between",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection:'column'
      },
    },
    headerOrderDetailsSingleBox:{
      display: "flex", 
      flexDirection: "column" ,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginTop:8
      },
    },
    downloadReceiptBTn: {
      backgroundColor: "#e5e5e5",
      color: "black",
      "&:hover": {
        backgroundColor: "silver",
        color: "black",
      },
      padding: 15,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "100%",
        marginTop:5
      },
    },
    receiptBox: {
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
      padding: 30,
      width: "100%",
      margin: 20,
    },
    logo: {
      maxWidth: "150px",
    },
    titleOfReceiptOrderSummaryProduct:{
      maxWidth: 300,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth:220,
        textOverflow:"ellipsis"
      },
    },
    titleOfReceiptProduct:{
      maxWidth: 300,
      textOverflow:'ellipsis',
      fontWeight:'bold',
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth:300
      },
    },
    receiptFooter:{
        display: "flex",
        justifyContent: "space-between",
        borderTop: "1px solid #e5e5e5",
        paddingTop: 15,
        [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
          flexDirection:'column'
        },
    },
    receiptSummaryBoxItem:{
      display: "flex",
      justifyContent: "space-between",
      paddingTop: 16,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection:'column'
      },
    },
    CartItemBox: {
      backgroundColor: "#fff",
      marginTop: 15,
      minWidth: '100%',
      border: "0.2px solid #e5e5e5",
      // boxShadow:' rgba(0, 0, 0, 0.16) 0px 1px 4px'
    },
    storeNameBox: {
      padding: 5,
      display: "flex",
      flexDirection: "column",
    },
    productDetailsBox: {
      padding: 15,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection:'column',
        justifyContent:'flex-start',
        alignItems:'flex-start'
      },
    },
    itemImageBox: {
      width: 100,
      height: 100,
      objectFit: "cover",
      marginRight: 20,
    },
    priceText: {
      color: myTheme.palette.primary.main,
      fontWeight: "bold",
    },
    priceSection: {
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft:9
      },
    },
  };
});

export default useStyles;
